import { render, staticRenderFns } from "./HJJCSB.vue?vue&type=template&id=ca4227f4&scoped=true&"
import script from "./HJJCSB.vue?vue&type=script&lang=js&"
export * from "./HJJCSB.vue?vue&type=script&lang=js&"
import style0 from "./HJJCSB.vue?vue&type=style&index=0&id=ca4227f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4227f4",
  null
  
)

export default component.exports